<template>
  <v-card v-resize="onResize" class="ma-0 pa-0" height="100%">
    <v-card-text>
      <!--
      <p class="text-center title pb-0 mb-0 text-h4">FM Meters Data Display</p>
      -->
      <p class="headline font-weight-medium text-uppercase font-italic py-0 my-0" style="color:#C7A754"> Usage Per
        Category </p>
    </v-card-text>
    <div id='mainGraph' style='height:800px;'></div>
  </v-card>
</template>
<!--
  echarts warning regardng DOM width and heigh is due to
  no inital load as element is stuck within stepper component
  can be ignored
-->
<script>
import _ from 'lodash'
import shine from '@/components/plugins/echarts-theme-shine';

export default {
  props: ["dataArray", "isLoading"],
  data: () => ({
    mainGraph: null,
    dataLabels: ['Cooling', "Building Consumption", 'PV'],
  }),
  watch: {
    isLoading: {
      handler() {
        if (this.isLoading) {
          this.mainGraph.showLoading();
        } else {
          this.mainGraph.hideLoading();
        }
      }
    },
    '$store.state.KBEUI.unit': function () {
      this.set_Graph()
    },
    dataArray: {
      handler() {
        this.set_Graph();
      }
    }
  },
  methods: {
    showGraph() {

      if (this.runState === "running") {
        this.mainGraph.showLoading()

      } else if (this.runState === "genGraph") {
        this.mainGraph.hideLoading()
        this.set_Graph();
      }
    },
    onResize() {  // calls echarts .resize function when viewing window changes
      if (this.mainGraph) _.debounce(this.mainGraph.resize, 100)()
    },
    set_Graph() {
      let option = {
        color: [
          '#f09706', '#bfcd38', "#ce561a", "#639719",
          '#6e47b7', '#3d86cf', "#9e9f93", "#b57dbd", '#bfcd38', "#ce561a",
        ],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['Cooling', 'Building Consumption', 'PV'],
          left: '10%'
        },
        grid: {
          bottom: 100
        },
        toolbox: {
          feature: {
            magicType: {
              type: ['stack']
            },
            dataView: {},
            saveAsImage: {},
          }
        },
        xAxis: {
          data: this.xAxis,
          axisLine: { onZero: true },
          splitLine: { show: false },
          splitArea: { show: false }
        },
        yAxis: {},
        series: this.seriesArray
      }
      this.mainGraph.setOption(option)
      this.onResize()
    },
  },
  computed: {
    xAxis() {
      return this.dataArray.map(function (value, index) { return value[0]; })
    },
    seriesArray() {
      let mult
      if (this.$store.state.KBEUI.unit == 'SI') {
        mult = 1
      } else {
        mult = 3.412
      }

      var arr = [];
      var len = this.dataLabels.length;
      for (var i = 0; i < len; i++) {
        arr.push({
          name: this.dataLabels[i],
          type: 'bar',
          stack: 'one',
          data: this.dataArray.map(function (value, index) { return (value[i + 1] * mult).toFixed(2) })
        });
      }
      return arr
    },
  },
  async mounted() {
    echarts.registerTheme('shine', shine)
    this.mainGraph = echarts.init(document.querySelector('#mainGraph'))
  }
}
</script>
